import { faCode } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString } from "et3-type-guards";
import React from "react";
import i18n from "../../../../../constants/i18n";
import getPromoCodeStore from "../../../../../stores/auditor-store/promocode-store";
import Et3Button from "../../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";

const PromoCodeUsageForm = withLiteObserverAndTheme(() => {
  const promoCodeHistory = getPromoCodeStore().promoCodeHistory.get();
  const disabled = !isDefinedString(promoCodeHistory);

  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"text"}
        icon={faCode}
        label={i18n.get("PROMO_CODE")}
        placeHolder={i18n.get("PROMO_CODE")}
        value={getPromoCodeStore().promoCodeHistory.get()}
        onChoose={(value: string) =>
          getPromoCodeStore().promoCodeHistory.set(value)
        }
        onBlur={() => {}}
        onEnter={() => {
          getPromoCodeStore().getPromoCodeUsageHistory();
        }}
        style={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={!disabled}
        onClick={async () => {
          getPromoCodeStore().getPromoCodeUsageHistory();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default PromoCodeUsageForm;
